
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IContactsByHubspotList, IHubspotListsForDropdown } from '@shared/services/api/legacy/hubspotlists-service/hubspotlist-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class HubspotListsService {

    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${HubspotListsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/hubspotlists';

    public getHubspotListsForDropdown(): Observable<SuccessResponse<IHubspotListsForDropdown> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IHubspotListsForDropdown>>(HubspotListsService.URL + '/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    getContactsByHubspotList(listId: number, hubspotPropertyId: string = null): Observable<SuccessResponse<IContactsByHubspotList> | ErrorResponse> {
        let url = HubspotListsService.URL + '/'+ listId + '/contacts';
        if(hubspotPropertyId) {
            url += '?ticketHolderPropertyId='+hubspotPropertyId;
        }
        return this.http
            .get<SuccessResponse<IContactsByHubspotList>>(url).pipe(catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
